import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXSocialIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.66 5.6h3.53l-7.71 8.81 9.07 11.99h-7.1l-5.565-7.27-6.36 7.27H4.99l8.245-9.425L4.54 5.6h7.28l5.025 6.645zm-1.24 18.69h1.955L10.755 7.6h-2.1z" })
});
export default SvgXSocialIcon;
